import { render } from "./ticketsConfig.vue?vue&type=template&id=fedf2030"
import script from "./ticketsConfig.vue?vue&type=script&lang=js"
export * from "./ticketsConfig.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/ticketsConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fedf2030"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fedf2030', __exports__)) {
    console.log('reload')
    api.reload('fedf2030', __exports__)
  }
  
  module.hot.accept("./ticketsConfig.vue?vue&type=template&id=fedf2030", () => {
    console.log('re-render')
    api.rerender('fedf2030', render)
  })

}


export default __exports__